const variantItemCustom = document.querySelectorAll('.variant-item-custom');

variantItemCustom.forEach(variant => {
  variant.addEventListener('click', () => {
    const variantInput = variant.querySelector('input.btn-check');

    if (variantInput) {
      updateSearchParam('variant', variantInput.value);
    }
  })
});

variantItemCustom.forEach(variant => {
  const variantInput = variant.querySelector('input.btn-check');

  if(variantInput.checked == true) {
    updateSearchParam('variant', variantInput.value);
  }
});

function updateSearchParam(key, value) {
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set(key, value);

  var newSearchString = searchParams.toString();
  window.history.replaceState({}, '', '?' + newSearchString);
}
